import React, {useContext} from 'react';
import './style.scss';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Tooltip from "@material-ui/core/es/Tooltip/Tooltip";
import moment from "moment";
import {AppContext} from "../../../../Utils/AppContext";


const STATUSES = ["ACCEPTED", "READY", "DELIVERED"];

export const STATUS_TO_DISPLAY = {
    "ACCEPTED": "התקבל",
    "READY": "מוכן",
    "ASSIGNED": "שובץ",
    "COLLECTED": "נאסף",
    "SENT": "נשלח",
    "DELIVERED": "נמסר"
};

export default function OrderStatusSwitcher(props) {
    const appContext = useContext(AppContext);
    const orderOrFirst = props.orders ? props.orders[0] : props.order;

    function getShiftedStatus(shift) {
        const currStatusIndex = STATUSES.indexOf(orderOrFirst.status);

        if (currStatusIndex + shift >= STATUSES.length || currStatusIndex + shift < 0)
            return STATUSES[currStatusIndex];

        return STATUSES[currStatusIndex + shift];
    }

    function handleOrderStatusChange(e, newStatus) {
        if (!newStatus)
            return;

        const ordersIdsToChange = props.orders ? props.orders.map(order => order.id) : [props.order.id];
        props.setOrdersStatus(appContext.bid, ordersIdsToChange, newStatus);
    }

    const direction = orderOrFirst.status === "ACCEPTED" ? 1 : -1;
    const isLastInDirection = (STATUSES.indexOf(orderOrFirst.status) + direction < 0) || (STATUSES.indexOf(orderOrFirst.status) + direction >= STATUSES.length);
    const isReadySlaPassed = props.readySla !== undefined && props.readySla !== null && orderOrFirst.status === 'ACCEPTED' && moment.duration(moment().diff(moment(new Date(orderOrFirst.orderTime)))).asMinutes() >= props.readySla

    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    return (
        <span
            className={`order-status-switcher ` + (direction === 1 ? "order-status-switcher-next" : "order-status-switcher-previous") + (isReadySlaPassed ? " order-status-switcher-ready-sla-passed" : "")}>
        <span className="order-status-switcher-content"
              onClick={(e) => {
                  if (!isTouchDevice())
                      handleOrderStatusChange(e, getShiftedStatus(direction))
              }}
              onTouchEnd={(e) => {
                  handleOrderStatusChange(e, getShiftedStatus(direction))
              }}>
                <Tooltip disableHoverListener={props.disabled}
                         disableTouchListener={props.disabled}
                         disableFocusListener={true}
                         arrow
                         title={`שנה לסטטוס ${STATUS_TO_DISPLAY[getShiftedStatus(direction)]}`}
                         className={`${isLastInDirection ? 'order-status-switcher-icon-button-hidden' : ''}`}>
                    <span className="order-status-switcher-icon-container">
                            <span
                                className={`order-status-switcher-icon-button order-status-switcher-${direction === 1 ? "next" : "previous"}-icon-button` + (props.disabled ? ' order-status-disabled-icon-button' : '')}>
                                    <NavigateNextIcon/>
                            </span>
                    </span>
                </Tooltip>
        </span>
        </span>
    );
}
